import { render, staticRenderFns } from "./FamilyLawManual.vue?vue&type=template&id=f325350c"
import script from "./FamilyLawManual.vue?vue&type=script&lang=ts"
export * from "./FamilyLawManual.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports